import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="forms--dashboard-widgets"
export default class extends Controller {
  static targets = ["dashboard"];
  static values = { dashboardsUrl: String };

  connect() {
    this.dashboardSelect = new TomSelect(this.dashboardTarget, {
      valueField: "id",
      labelField: "title",
      searchField: "title",
      preload: true,
      load: (query, callback) => {
        if (this.loading > 1) {
          callback();
          return;
        }

        fetch(this.dashboardsUrlValue)
          .then((response) => response.json())
          .then((json) => {
            callback(json);
          })
          .catch(() => {
            callback();
          });
      },
    });
  }
}
